const blockShopList = () => {
	const allBtnShowMorePartner = document.querySelectorAll('.js-see-all-partners');
	const allShopWrapParnter = document.querySelectorAll('.js-shop-wrap-partner');

	if (allBtnShowMorePartner && allShopWrapParnter) {
		allBtnShowMorePartner.forEach((el) => {
			el.addEventListener('click', (e) => {
				const targetCapacity = e.currentTarget.getAttribute('data-capacity');
				e.currentTarget.classList.add('hidden');
				allShopWrapParnter.forEach((wraper) => {
					const wrapperCapacity = wraper.getAttribute('data-capacity');
					if (wrapperCapacity == targetCapacity) wraper.classList.add('show-all');
				});
			});
		});
	}
};

export default blockShopList;
